// extracted by mini-css-extract-plugin
module.exports = {"action":"Action_action__1ICBM","inactive":"Action_inactive__TCvfV","text":"Action_text__1NQgM"};